import { useEffect, useState, useRef } from '@wordpress/element';
import MapPopup from '../map-popup/popup';
import svgPin from '../../assets/images/map-pin.svg';
import svgPinBlack from '../../assets/images/map-pin-black.svg';
import styles from './themes/airbnb.json';
import './styles.scss';
let gMarkers = [];
const Map = ({
    onClick,
    markers,
    center,
    zoom,
    page,
    hoverId,
    usePopup = false
}) => {
    const [isLoadingApi, setLoadingApi] = useState(true);
    const [map, setMap] = useState(null);
    const mapRef = useRef(null);
    const apiKey = window.googleMapSettings?.apiKey || '';

    const initMarkers  = () => {
        gMarkers.forEach(marker => {
            marker.setMap(null);
        }); 

        gMarkers = markers.map(marker => {
            return new google.maps.Marker({
                position: {lat: marker.latitude, lng: marker.longitude },
                map: map,
                icon: svgPin,
                id: marker.id
            });
        });

        if (gMarkers.length === 1 && center) {
            map.setCenter( {lat: center.latitude, lng: center.longitude} );
        }

        if (zoom) {
            map.setZoom(zoom);
        }

        const bounds = new google.maps.LatLngBounds();
        gMarkers.forEach((gmarker, index) => {
            gmarker.setPosition({lat: markers[index].latitude, lng: markers[index].longitude});
            bounds.extend(gmarker.position);

            if (usePopup) {
                 gmarker.addListener('click', function() {
                    const popup = MapPopup({
                        maps:  window.google.maps,
                        latitude: markers[index].latitude,
                        longitude: markers[index].longitude,
                        title: markers[index].title,
                        images: markers[index].images,
                        text: markers[index].text ? markers[index].text : '',
                        category: markers[index].category,
                        link: markers[index].link
                     });

                     popup.setMap(map);
                 });

                 gmarker.addListener('mouseover', function() {
                    gmarker.setIcon(svgPinBlack);
                 });

                 gmarker.addListener('mouseout', function() {
                    gmarker.setIcon(svgPin);
                 });
            }
        });

        if (!zoom & !center) {
            map.fitBounds(bounds);

            map.maxDefaultZoom = 15;
            window.google.maps.event.addListenerOnce(map, 'bounds_changed', function () {
                this.setZoom(Math.min(this.getZoom(), this.maxDefaultZoom));
            });                
        }
    };

    useEffect(() => {
        if(!apiKey){
            return;
        }

        if (map) {
            return;
        }

        if (!isLoadingApi) {
            return;
        }

        const loadGoogleMapsScript = async () => {
            if (document.getElementById('google-maps-api')) {
                return;
            }

            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
            script.id = 'google-maps-api';
            script.defer = true;
            script.async = true;
            script.onload = () => {
                setLoadingApi(false); 
            };
      
            document.body.appendChild(script);
        };

        loadGoogleMapsScript();
    }, [apiKey, map]);

    useEffect(() => {
        if (!isLoadingApi && !map) {
            const googleMap = new window.google.maps.Map(mapRef.current, {
                center: center && { lat: center.latitude, lng: center.longitude },
                zoom: zoom,
                streetViewControl: false,
                mapTypeControl: false,
                scrollwheel: false,
                styles
            });

            if (onClick) {
                googleMap.addListener('click', (mapsMouseEvent) => {
                    onClick(mapsMouseEvent.latLng.toJSON(), googleMap.getZoom());
                });
            }

            setMap(googleMap); 
        }
    }, [isLoadingApi, map]);

    useEffect(() => {
        if (!isLoadingApi && map) {
            initMarkers();
        }
    }, [isLoadingApi, map]);

    useEffect(() => {
        if (!isLoadingApi && map && onClick) {
            initMarkers();
        }
    }, [markers]);


    useEffect(() => {
        if (!isLoadingApi && map) {
            initMarkers();
        }
    }, [markers.length]);

    useEffect(() => {
        if (!isLoadingApi && map) {
            gMarkers.forEach(marker => {
                if (markers.find(f => f.isHover) && markers.find(f => f.isHover).id === marker.id ) {
                    marker.setIcon(svgPinBlack);        
                } else {
                    marker.setIcon(svgPin);
                }
            });
        }
    }, [hoverId]);

    useEffect(() => {
        if (!isLoadingApi && map) {
            initMarkers();
        }
    }, [page]);

    return (
        <div className="map"
			ref={mapRef}>
		</div>
    );
};

export default Map;